import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  alignRight: {
    textAlign: 'right',
  },
  attempt: {
    margin: 0,
  },
  goal: {
    color: 'green',
  },
  miss: {
    color: 'red',
  },
}));

const ShootoutAttempt = ({ attempt, isHome, skaters }) => {
  const classes = useStyles(isHome);

  // Find a players name
  function findPlayer(player){
    const skater = skaters[player];

    if(skater){
      return skater.name;
    }

    // Can't find it, just return what was given
    return player;
  }

  return (
    <Grid container spacing="1" className={classes.attempt}>
      { isHome && (
        <Grid item xs={3} md={2} lg={1} className={classes.attemptIcon}>
          { attempt.result === 'goal' && <CheckCircleIcon className={classes.goal} /> }
          { attempt.result === 'miss' && <CancelIcon className={classes.miss} />}
          { attempt.result === 'pending' && <CheckBoxOutlineBlankIcon />}
        </Grid>
      )}
      <Grid item xs={9} md={10} lg={11}>
        <Typography
          align={isHome ? undefined : 'right'}
          component="p"
          variant="caption"
        >
          {findPlayer(attempt.player)}
        </Typography>
      </Grid>
      { !isHome && (
        <Grid item xs={3} md={2} lg={1} className={clsx(classes.attemptIcon, classes.alignRight)}>
          { attempt.result === 'goal' && <CheckCircleIcon className={classes.goal} /> }
          { attempt.result === 'miss' && <CancelIcon className={classes.miss} />}
          { attempt.result === 'pending' && <CheckBoxOutlineBlankIcon />}
        </Grid>
      )}
    </Grid>
  );
}


export default ShootoutAttempt;